//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v10.9.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

import { ClientBase } from "../ClientBase";
import { ClientBaseMes } from "../ClientBaseMes";

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

export class OptimaImageClient extends ClientBaseMes {
  private http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor(baseUrl?: string, http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
    super();
    this.http = http ? http : (window as any);
    this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
  }

  /**
   * @param api_version (optional)
   * @return Success
   */
  healthGet(api_version: string | undefined): Promise<void> {
    let url_ = this.baseUrl + "/Health?";
    if (api_version === null) throw new Error("The parameter 'api_version' cannot be null.");
    else if (api_version !== undefined) url_ += "api-version=" + encodeURIComponent("" + api_version) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processHealthGet(_response);
      });
  }

  protected processHealthGet(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param pageIndex (optional)
   * @param pageSize (optional)
   * @return Success
   * @deprecated
   */
  mediaSearch(
    searchTerm: string,
    searchType: string,
    pageIndex: number | undefined,
    pageSize: number | undefined
  ): Promise<SearchMediaResponse[]> {
    let url_ = this.baseUrl + "/v1/Media/search?";
    if (searchTerm === undefined || searchTerm === null)
      throw new Error("The parameter 'searchTerm' must be defined and cannot be null.");
    else url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    if (searchType === undefined || searchType === null)
      throw new Error("The parameter 'searchType' must be defined and cannot be null.");
    else url_ += "searchType=" + encodeURIComponent("" + searchType) + "&";
    if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
    else if (pageIndex !== undefined) url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
    if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processMediaSearch(_response);
      });
  }

  protected processMediaSearch(response: Response): Promise<SearchMediaResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(SearchMediaResponse.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<SearchMediaResponse[]>(null as any);
  }

  assetGet(assetId: string): Promise<GetAssetResponse> {
    let url_ = this.baseUrl + "/api/assets/{assetId}";

    if (assetId === undefined || assetId === null) throw new Error("The parameter 'assetId' must be defined.");
    url_ = url_.replace("{assetId}", encodeURIComponent("" + assetId));

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processMediaGet(_response);
      });
  }

  /**
   * @return Success
   */
  mediaGet(contentId: string, versionId: string): Promise<GetAssetResponse> {
    let url_ = this.baseUrl + "/v1/Media/{contentId}/{versionId}";
    if (contentId === undefined || contentId === null) throw new Error("The parameter 'contentId' must be defined.");
    url_ = url_.replace("{contentId}", encodeURIComponent("" + contentId));
    if (versionId === undefined || versionId === null) throw new Error("The parameter 'versionId' must be defined.");
    url_ = url_.replace("{versionId}", encodeURIComponent("" + versionId));
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processMediaGet(_response);
      });
  }

  protected processMediaGet(response: Response): Promise<GetAssetResponse> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        result200 = GetAssetResponse.fromJS(resultData200);
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetAssetResponse>(null as any);
  }

  /**
   * @param pageIndex (optional)
   * @param pageSize (optional)
   * @return Success
   */
  mediaFind(
    searchTerm: string,
    pageIndex: number | undefined,
    pageSize: number | undefined
  ): Promise<GetAssetResponse[]> {
    let url_ = this.baseUrl + "/v1/Media/find?";
    if (searchTerm === undefined || searchTerm === null)
      throw new Error("The parameter 'searchTerm' must be defined and cannot be null.");
    else url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
    else if (pageIndex !== undefined) url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
    if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processMediaFind(_response);
      });
  }

  protected processMediaFind(response: Response): Promise<GetAssetResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(GetAssetResponse.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<GetAssetResponse[]>(null as any);
  }

  /**
   * @param assetId (optional)
   * @return Success
   */
  publishPublish(assetId: number | undefined): Promise<void> {
    let url_ = this.baseUrl + "/v1/Publish?";
    if (assetId === null) throw new Error("The parameter 'assetId' cannot be null.");
    else if (assetId !== undefined) url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPublishPublish(_response);
      });
  }

  protected processPublishPublish(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param assetId (optional)
   * @return Success
   */
  publishPublish2(assetId: number | undefined): Promise<void> {
    let url_ = this.baseUrl + "/v1/Publish/Publish2?";
    if (assetId === null) throw new Error("The parameter 'assetId' cannot be null.");
    else if (assetId !== undefined) url_ += "assetId=" + encodeURIComponent("" + assetId) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {},
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPublishPublish2(_response);
      });
  }

  protected processPublishPublish2(response: Response): Promise<void> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<void>(null as any);
  }

  /**
   * @param pageIndex (optional)
   * @param pageSize (optional)
   * @return Success
   */
  publishSearch(
    searchTerm: string,
    searchType: string,
    pageIndex: number | undefined,
    pageSize: number | undefined
  ): Promise<SearchAssetResponse[]> {
    let url_ = this.baseUrl + "/v1/Publish/search?";
    if (searchTerm === undefined || searchTerm === null)
      throw new Error("The parameter 'searchTerm' must be defined and cannot be null.");
    else url_ += "searchTerm=" + encodeURIComponent("" + searchTerm) + "&";
    if (searchType === undefined || searchType === null)
      throw new Error("The parameter 'searchType' must be defined and cannot be null.");
    else url_ += "searchType=" + encodeURIComponent("" + searchType) + "&";
    if (pageIndex === null) throw new Error("The parameter 'pageIndex' cannot be null.");
    else if (pageIndex !== undefined) url_ += "pageIndex=" + encodeURIComponent("" + pageIndex) + "&";
    if (pageSize === null) throw new Error("The parameter 'pageSize' cannot be null.");
    else if (pageSize !== undefined) url_ += "pageSize=" + encodeURIComponent("" + pageSize) + "&";
    url_ = url_.replace(/[?&]$/, "");

    let options_: RequestInit = {
      method: "GET",
      headers: {
        Accept: "text/plain",
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.processPublishSearch(_response);
      });
  }

  protected processPublishSearch(response: Response): Promise<SearchAssetResponse[]> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
        if (Array.isArray(resultData200)) {
          result200 = [] as any;
          for (let item of resultData200) result200!.push(SearchAssetResponse.fromJS(item));
        } else {
          result200 = <any>null;
        }
        return result200;
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException("An unexpected server error occurred.", status, _responseText, _headers);
      });
    }
    return Promise.resolve<SearchAssetResponse[]>(null as any);
  }
}

export class GetAssetPropertyResponse implements IGetAssetPropertyResponse {
  name?: string | undefined;
  value?: string | undefined;

  constructor(data?: IGetAssetPropertyResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.name = _data["name"];
      this.value = _data["value"];
    }
  }

  static fromJS(data: any): GetAssetPropertyResponse {
    data = typeof data === "object" ? data : {};
    let result = new GetAssetPropertyResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["name"] = this.name;
    data["value"] = this.value;
    return data;
  }
}

export interface IGetAssetPropertyResponse {
  name?: string | undefined;
  value?: string | undefined;
}

export class GetAssetResponse implements IGetAssetResponse {
  contentId?: string;
  versionId?: string;
  sourceId?: string | undefined;
  deprecated?: boolean;
  url?: string | undefined;
  properties?: GetAssetPropertyResponse[] | undefined;

  constructor(data?: IGetAssetResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.contentId = _data["contentId"];
      this.versionId = _data["versionId"];
      this.sourceId = _data["sourceId"];
      this.deprecated = _data["deprecated"];
      this.url = _data["url"];
      if (Array.isArray(_data["properties"])) {
        this.properties = [] as any;
        for (let item of _data["properties"]) this.properties!.push(GetAssetPropertyResponse.fromJS(item));
      }
    }
  }

  static fromJS(data: any): GetAssetResponse {
    data = typeof data === "object" ? data : {};
    let result = new GetAssetResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["contentId"] = this.contentId;
    data["versionId"] = this.versionId;
    data["sourceId"] = this.sourceId;
    data["deprecated"] = this.deprecated;
    data["url"] = this.url;
    if (Array.isArray(this.properties)) {
      data["properties"] = [];
      for (let item of this.properties) data["properties"].push(item.toJSON());
    }
    return data;
  }
}

export interface IGetAssetResponse {
  contentId?: string;
  versionId?: string;
  sourceId?: string | undefined;
  deprecated?: boolean;
  url?: string | undefined;
  properties?: GetAssetPropertyResponse[] | undefined;
}

export class PublishedStatus implements IPublishedStatus {
  sourceId?: string | undefined;
  storageAccount?: boolean;
  contentDelivery?: boolean;
  mediaService?: boolean;
  readonly published?: boolean;

  constructor(data?: IPublishedStatus) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.sourceId = _data["sourceId"];
      this.storageAccount = _data["storageAccount"];
      this.contentDelivery = _data["contentDelivery"];
      this.mediaService = _data["mediaService"];
      (<any>this).published = _data["published"];
    }
  }

  static fromJS(data: any): PublishedStatus {
    data = typeof data === "object" ? data : {};
    let result = new PublishedStatus();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["sourceId"] = this.sourceId;
    data["storageAccount"] = this.storageAccount;
    data["contentDelivery"] = this.contentDelivery;
    data["mediaService"] = this.mediaService;
    data["published"] = this.published;
    return data;
  }
}

export interface IPublishedStatus {
  sourceId?: string | undefined;
  storageAccount?: boolean;
  contentDelivery?: boolean;
  mediaService?: boolean;
  published?: boolean;
}

export class SearchAssetResponse implements ISearchAssetResponse {
  assetId?: string | undefined;
  readonly filename?: string | undefined;
  readonly thumbnail?: string | undefined;
  readonly keywords?: string | undefined;
  readonly description?: string | undefined;
  status?: PublishedStatus;

  constructor(data?: ISearchAssetResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.assetId = _data["assetId"];
      (<any>this).filename = _data["filename"];
      (<any>this).thumbnail = _data["thumbnail"];
      (<any>this).keywords = _data["keywords"];
      (<any>this).description = _data["description"];
      this.status = _data["status"] ? PublishedStatus.fromJS(_data["status"]) : <any>undefined;
    }
  }

  static fromJS(data: any): SearchAssetResponse {
    data = typeof data === "object" ? data : {};
    let result = new SearchAssetResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["assetId"] = this.assetId;
    data["filename"] = this.filename;
    data["thumbnail"] = this.thumbnail;
    data["keywords"] = this.keywords;
    data["description"] = this.description;
    data["status"] = this.status ? this.status.toJSON() : <any>undefined;
    return data;
  }
}

export interface ISearchAssetResponse {
  assetId?: string | undefined;
  filename?: string | undefined;
  thumbnail?: string | undefined;
  keywords?: string | undefined;
  description?: string | undefined;
  status?: PublishedStatus;
}

export class SearchMediaResponse implements ISearchMediaResponse {
  fileId?: string | undefined;
  contentId?: string | undefined;
  versionId?: string | undefined;
  url?: string | undefined;
  status?: Status;

  constructor(data?: ISearchMediaResponse) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property)) (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(_data?: any) {
    if (_data) {
      this.fileId = _data["fileId"];
      this.contentId = _data["contentId"];
      this.versionId = _data["versionId"];
      this.url = _data["url"];
      this.status = _data["status"];
    }
  }

  static fromJS(data: any): SearchMediaResponse {
    data = typeof data === "object" ? data : {};
    let result = new SearchMediaResponse();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === "object" ? data : {};
    data["fileId"] = this.fileId;
    data["contentId"] = this.contentId;
    data["versionId"] = this.versionId;
    data["url"] = this.url;
    data["status"] = this.status;
    return data;
  }
}

export interface ISearchMediaResponse {
  fileId?: string | undefined;
  contentId?: string | undefined;
  versionId?: string | undefined;
  url?: string | undefined;
  status?: Status;
}

export enum Status {
  None = "None",
  Published = "Published",
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(message: string, status: number, response: string, headers: { [key: string]: any }, result: any) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new ApiException(message, status, response, headers, null);
}
